import React from 'react';
import HubspotForm from '../HubspotForm/HubspotForm';

import './index.scss';

function TextHubspotForm({ block, centerContent = false, inline = false, wrapperVariant = '' }) {
  const { id, title, backgroundColor, description, variant, smallTitle = false, hasMemberPartiesLogic = false } = block;

  return (
    <div
      className={`text-hubspot-form ${backgroundColor} ${centerContent ? 'text-center' : ''} ${
        variant === 'column-small' ? 'p-0 pb-5' : ''
      } ${wrapperVariant ? wrapperVariant : ''}`}
    >
      <div className={`${!inline ? 'container' : ''}`}>
        <div className={`hubspot-container ${variant} ${centerContent ? 'form-center' : ''}`}>
          {title && <h2 className={`${smallTitle ? 'sm' : ''}`}>{title}</h2>}
          {description && <div className="description" dangerouslySetInnerHTML={{ __html: description }} />}

          <HubspotForm id={id} {...block.hubspot} hasMemberPartiesLogic={hasMemberPartiesLogic} />
        </div>
      </div>
    </div>
  );
}

export default TextHubspotForm;
